// 展示附赠权益的menuId： 测试环境：3659， 模拟环境：743，正式环境：2009
// export const BENEFITS_MENU_IDS = ['1750'] // TODO 测试数据去除
export const BENEFITS_MENU_IDS = ['3659', '743', '2009']
export const benefitLink = 'https://www.esign.cn/c/2025-12-04/520491.shtml'
